import { appendSerpBanner } from './appendSerpBanner'

const run = () => {
  // Add GTM helpers here
  global.gtmHelpers = { appendSerpBanner }
}

run()
